<template>
  <div class="event-item">
    <cdr-text class="event-item__title">{{ title }}</cdr-text>
    <div v-if="startDate === endDate">
      <cdr-text
        class="event-item__text"
        data-ui="single-date-start">{{ startDate }}</cdr-text>
      <cdr-text
        class="event-item__text"
        data-ui="single-date-time"
      >{{ startTime }}-{{ endTime }}
      </cdr-text>
    </div>
    <div v-else>
      <cdr-text
        class="event-item__text"
        data-ui="multi-date-start"
      >{{ multiDayStart }}</cdr-text>
      <cdr-text
        class="event-item__text"
        data-ui="multi-date-end"
      >{{ multiDayEnd }}</cdr-text>
    </div>
    <div class="event-item__location">
      <icon-location-pin-fill
        class="event-item__location-icon"
        size="small" />
      <cdr-text
        class="event-item__text"
        tag="span"
        data-ui="location"
      >
        {{ loc }}
      </cdr-text>
    </div>
  </div>
</template>

<script>
import { CdrText, IconLocationPinFill } from '@rei/cedar';
import moment from 'moment';
import constants from '../../../common/constants';

export default {
  name: 'EventItem',
  components: {
    CdrText,
    IconLocationPinFill,
  },
  props: {
    endDate: {
      type: String,
      required: true,
    },
    endTime: {
      type: String,
      required: true,
    },
    loc: {
      type: String,
      required: true,
    },
    startDate: {
      type: String,
      required: true,
    },
    startTime: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    multiDayStart() {
      return `${this.startDate} ${this.startTime} -`;
    },
    multiDayEnd() {
      return `${this.endDate} ${this.endTime}`;
    },
  },
};
</script>
